export class Utils {
    public static toggleScroll(): void {
        const overlays: NodeListOf<HTMLElement> = document.querySelectorAll(`.overlay-modal`);
        if (!overlays) return;

        const documentWidth = document.documentElement.clientWidth;
        const windowWidth = window.innerWidth;
        const scrollbarWidth = windowWidth - documentWidth;

        if ((getComputedStyle(document.body).overflow === `hidden`)) {
            document.body.style.overflow = ``;
            overlays.forEach((overlay) => {
                overlay.style.paddingRight = `unset`;
            });
        } else {
            document.body.style.overflow = `hidden`;
            overlays.forEach((overlay) => {
                overlay.style.paddingRight = `${scrollbarWidth}px`;
            });
        }
    }

    public static toggleClass(element: HTMLElement, className: string): void {
        if (!element) return;
        element.classList.toggle(className);
    };

    public static removeClass(element: HTMLElement, className: string): void {
        if (!element) return;
        element.classList.remove(className);
    };

    public static addClass(element: HTMLElement, className: string): void {
        if (!element) return;
        element.classList.add(className);
    };

    public static delay(ms: number) {
        return new Promise((resolve, reject) => {
            setTimeout(resolve, ms);
        });
    };

    public static fadeOut(element: HTMLElement, ms: number = 300): void {
        element.style.transition = `opacity ${ms}ms ease`;
        element.style.opacity = `0`;
        Utils.delay(ms).then(() => {
            element.style.display = `none`;
        });
    };

    public static getOuterWidth(element: HTMLElement):number {
        const computedStyle = getComputedStyle(element);
        return element.getBoundingClientRect().width + parseFloat(computedStyle.marginLeft) + parseFloat(computedStyle.marginRight);
    };

    public static getInnerWidth(element: HTMLElement):number {
        const computedStyle = getComputedStyle(element);
        return element.getBoundingClientRect().width - parseFloat(computedStyle.paddingLeft) - parseFloat(computedStyle.paddingRight);
    };

    public static getLang(): string {
        return document.documentElement.getAttribute(`lang`).toLowerCase();
    };

}